import { DocumentDetail, DocumentTask, EditDocument, SubmittedDocument } from '../types';

export function mapToEditDocument(
  document: SubmittedDocument | DocumentDetail,
): EditDocument {
  return {
    id: document.id,
    title: document.title,
    tasks: (document.document_tasks ?? []).map((data: DocumentTask) => ({
      id: data.task_instance.id,
      label: data.task_instance?.title ?? '',
    })),
    document_type: document.document_type
      ? {
          id: document.document_type.id,
          label: document.document_type.name,
        }
      : null,
    attribute_type: document.attribute_type
      ? {
          id: document.attribute_type.id,
          label: document.attribute_type.name,
        }
      : null,
    wcg_name: document.wcg_name ?? null,
  };
}
